import { motion } from "framer-motion";
import { ArrowRight, Calendar, Users } from "lucide-react";
import { Link } from "react-router";

export const Courses = () => {
  const courses = [
    {
      title: "Screen-Free Coding and Computational Thinking",
      description: "Hands-on, unplugged learning that builds logic, patterns, and sequencing without screens.",
      age: "5-10 years",
      duration: "Quarterly enrolments (3 months)",
      image: "/images/boy-playing-with-colorful-atoms-game-home.jpg",
      path: "/courses/screen-free",
    },
    {
      title: "Online Computational Thinking and Coding Program",
      description:
        "A live, interactive online version of our classroom program that builds strong computational thinking skills.",
      age: "5-10 years",
      duration: "6 months – 1 year",
      image: "/images/medium-shot-boy-with-laptop_23-2148551604.jpg",
      path: "/courses/online",
    },
    {
      title: "Scratch Programming",
      description: "Learn to code with colorful blocks, create games and animations, and build creative confidence.",
      age: "6-10 years",
      duration: "4-6 months",
      image: "/images/learn-home-coding-robot-cars.jpg",
      path: "/courses/scratch",
    },
    {
      title: "Bot Programming",
      description: "Program real bots with sequences, logic, and challenges using a screen-free, hands-on approach.",
      age: "6-12 years",
      duration: "3 months",
      image: "/images/little-boy-kid-child-constructor-checking-technical-toy.jpg",
      path: "/courses/bot-programming",
    },
    {
      title: "Home & Online Coaching",
      description: "Personalized coaching for IB, IGCSE, ICSE, and CBSE students across core subjects.",
      age: "School students",
      duration: "Flexible scheduling",
      image: "/images/medium-shot-boy-with-laptop_23-2148551604.jpg",
      path: "/courses/home-coaching",
    },
  ];

  return (
    <div className="w-full bg-white">
      <section className="relative overflow-hidden bg-linear-to-br from-orange-50 via-white to-orange-100">
        <div className="max-w-7xl mx-auto px-4 py-20 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-bold text-gray-900"
          >
            Courses that make kids think, create, and grow
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-lg text-gray-700 mt-4 max-w-3xl mx-auto"
          >
            Explore our screen-free, online, and advanced programs designed to build computational thinking, creativity,
            and confidence at every stage.
          </motion.p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <motion.div
              key={course.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden flex flex-col"
            >
              <div className="h-48 overflow-hidden">
                <img src={course.image} alt={course.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{course.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6">{course.description}</p>
                <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-6">
                  <div className="flex items-center gap-2">
                    <Users className="w-4 h-4 text-primary" />
                    <span>{course.age}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-primary" />
                    <span>{course.duration}</span>
                  </div>
                </div>
                <Link
                  to={course.path}
                  className="inline-flex items-center gap-2 text-primary font-semibold mt-auto hover:underline"
                >
                  View course <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Courses;
